import React, { useContext } from "react";
import {Helmet} from "react-helmet";
import "./Betasignup.css";
//import rent_loader from "../../assets/images/Loader_Rentid_White.svg";
//import AnimationComponent from './loader_animation.jsx';
//import { toast } from 'react-toastify';
// import { Col, Container, Row } from 'react-bootstrap'
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
//import BetaForm from "../BetaForm";
import { UserContext } from "../../context/FormDataContext";;
//import log_anima from "../../assets/images/white_loader.gif";

const Betasignup = () => {
  const { userData } = useContext(UserContext);
  //const [loading, setLoading] = useState(false); 
  //const toastId = React.useRef(null);// State for loader

  /*const notify = (message) => {
    if (!toastId.current) { // Prevent re-assigning an ID if it's already set
      toastId.current = toast.info(message, {
        position: "top-right",
        autoClose: 5000,
        draggable: true,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        theme: "dark",
        toastId: "beta-signup", // Unique ID to prevent duplicate toasts
      });
    }
  };*/

 /* const handleContinueToBeta = () => {
    if(process.env.REACT_APP_ENABLE_BETA === "true"){
      setLoading(true);
      setTimeout(() => {
        setLoading(false); 
        const modal = new window.bootstrap.Modal(document.getElementById('exampleModal'));
        modal.show(); 
      }, 2000); 
    }else{
      notify('Beta Access signup will be available soon.');
    }

  };*/


  const userdata = userData;
  console.log(userdata,'dnfgdjfgn')

  const copyToClipboard = () => {
    const staticLink = "https://rentid.io/"; // Static link to copy
    navigator.clipboard.writeText(staticLink)
  };
  

  return (
    <div>
      <Helmet>
        <title>RentId | Wait List</title>
        <meta property="og:title" content="RentId | Wait List" />
        <meta name="twitter:title" content="RentId | Wait List" />
        <meta name="description" content="RentId Wait List" />
        <meta name="twitter:description" content="RentId Guest Login" />
        <meta property="og:description" content="RentId Guest Login" />
        <meta name="keywords" content="Car Rental Support, Refund Policies, Insurance, Cancellation, Support, Guest, Resource Center, Rental Empowerment, Guidelines" />
        <meta property="og:url" content="https://www.rentid.io/beta-signup" />
        <link rel="canonical" href="https://www.rentid.io/beta-signup" />
      </Helmet>
      <main className="main beta-signup">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 col-xs-12 col-md-12 col-lg-4 p-0 banner-img">
            {/* <a href="/">
                <img
                  src="/img/beta-signup/Close-X.png"
                  className="img-fluid cross-icon"
                  alt="close"
                />
              </a> */}
              <div className="banner-img">
                  <div className="bannerBetaInner">
             
                      <div className="main-logo">
                        <a href="/">
                          <img
                            src="/img/beta-signup/Rentid-white-logo.svg"
                            className="img-fluid d-none d-lg-block"
                            alt="Rentid Logo"
                          />
                        </a>
                        <a href="/">
                          <img
                            src="/img/mobile-logo.svg"
                            className="img-fluid d-lg-none"
                            alt="Rentid Mobile Logo"
                          />
                        </a>
                      </div>
                 
                      <div className="bannerBetaData">
                        <div className="checkBeta text-center">
                         {/* <AnimationComponent/> */}
                         <img width="56" src="/img/check_green.svg" alt=""/>
                        </div>
                        <p className="congrats-text">Congratulations</p>
                        {/* <p className="congrats-text">Congratulations</p> */}
                        <div className="details-section">
                  
                            <p className="user-name text-center">
                              {userData.firstName} {userData.lastName} <br />
                              {userData.companyName}
                            </p>
                            <p className="thank-you-text">
                              Thank you for joining our waitlist!
                            </p>
                            <p className="desc-notes mb-2 mb-md-5">
                              We're excited to have you on this journey with us!
                              Please check your email for a confirmation and
                              further details. We'll keep you updated with the
                              latest news and developments as we get closer to
                              launch.
                            </p>
                            <p className="desc-notes mb-3">
                              In the meantime, feel free to share Rentid with
                              your friends - We can't wait to welcome everyone!
                            </p>
                            <h3 className="rent-team">-Team Rentid</h3>
                            <div className="btnBeta">
                              <a class="btn btnWhiteBeta" href="/">Back to home page</a>
                              <button type="button" onClick={copyToClipboard} className="btn btnBlueBeta">
                                <img src="/img/beta-signup/share.svg" className="img-fluid" alt="feature img"/> Share rentid with a friend
                              </button>
                            </div>
                        </div>
                      </div>
                   
          

                    {/* <div className="row footer-section">
                      <div className="col-12 text-center">
                        <p className="leagal-footer">
                          <span>
                            <img
                              src="/img/beta-signup/elements.png"
                              className="img-fluid"
                              alt="copy right"
                            />
                            {new Date().getFullYear()} Rentid Inc.
                          </span>
                          <span className="ms-3 footer-link">
                            <a href="/terms" target="_blank">Legal</a>
                          </span>
                        </p>
                      </div>
                    </div> */}
                   
                  </div>
              
              </div>
                <div className="betaFooter">
                  <p>&copy; 2024 Rentid Inc.</p><a href="/terms">Legal</a>
                </div>
            </div>
            {/* <div className="col-12 col-xs-12 col-md-12 col-lg-8 p-0">
              <a href="/">
                <img
                  src="/img/beta-signup/Close-X.png"
                  className="img-fluid cross-icon"
                  alt="close"
                />
              </a>
              <div className="row center-row align-items-center">
                <div className="col-12 text-md-center">
                  <p className="ready-text mb-4">Ready for early access?</p>
                  <p className="continue-signup mb-4">
                    Continue and sign up for beta
                  </p>
                  <p className="time-takes mb-4">
                    Takes approximately 5 minutes
                  </p>
                  <button
                    type="button"
                    className="btn btn-radius"
                    onClick={handleContinueToBeta}
                  >
                    Continue to beta
                  </button>

               
                  {loading && (
                    <div className="loader-background">
                      <div className="loader">
                        <img src={rent_loader} alt="Loading" />
                        <p>Loading...</p>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div className="row footer-section">
                <div className="col-12 text-center">
                  <p className="leagal-footer">
                    <span>
                      <img
                        src="/img/beta-signup/elements.png"
                        className="img-fluid"
                        alt="copy right"
                      />
                      {new Date().getFullYear()} Rentid Inc.
                    </span>
                    <span className="ms-3 footer-link">
                      <a href="/terms" target="_blank">Legal</a>
                    </span>
                  </p>
                </div>
              </div>
            </div> */}
          </div>



        </div>

    
        {/* <BetaForm loading={loading} />  */}
      </main>
      
    </div>

  );
};

export default Betasignup;
